module.exports = __webpack_public_path__ + "static/vo-52a594504ad0d6b5de16f63762e47f57.mp3";